import { ShipIcon } from "../../../shared/Icons";
import { AdminSidebarIconProps } from "../../models/admin.models";
import {
  BugAntIcon,
  CalculatorIcon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  HomeIcon,
  KeyIcon,
  ShieldCheckIcon,
  SwatchIcon,
  Square3Stack3DIcon,
  MagnifyingGlassCircleIcon,
} from "@heroicons/react/24/outline";

const AdminSidebarIcon = ({ id }: AdminSidebarIconProps) => {
  const iconClassName = "h-5 w-5 flex-shrink-0";

  if (id === "aiScans") {
    return <MagnifyingGlassCircleIcon className={iconClassName} />;
  }

  if (id === "aiFlows") {
    return <Square3Stack3DIcon className={iconClassName} />;
  }

  if (id === "dashboard") {
    return <HomeIcon className={iconClassName} />;
  }

  if (id === "emails") {
    return <EnvelopeIcon className={iconClassName} />;
  }

  if (id === "debug") {
    return <BugAntIcon className={iconClassName} />;
  }

  if (id === "monitoring") {
    return <ChartBarIcon className={iconClassName} />;
  }

  if (id === "voyagePnl") {
    return <CalculatorIcon className={iconClassName} />;
  }

  if (id === "certificates" || id === "certificatesSettings") {
    return <DocumentTextIcon className={iconClassName} />;
  }

  if (id === "kpis") {
    return <ChartBarIcon className={iconClassName} />;
  }

  if (id === "crewReport") {
    return <ClipboardDocumentListIcon className={iconClassName} />;
  }

  if (id === "keysSecrets") {
    return <KeyIcon className={iconClassName} />;
  }

  if (id === "accessControl") {
    return <ShieldCheckIcon className={iconClassName} />;
  }

  if (id === "uwhc") {
    return <ShipIcon className={iconClassName} />;
  }

  if (id === "paintSchemes") {
    return <SwatchIcon className={iconClassName} />;
  }

  return <ShipIcon className={iconClassName} />;
};

export default AdminSidebarIcon;
